import Cookies from 'js-cookie';
import { GlobalCfg } from '../conf';

const mappings = {
    '%': '-PERCENT-',
    '#': '-HASH-',
    '?': '-QUESTION-',
};

const reverseMappings = {
    '-PERCENT-': '%',
    '-HASH-': '#',
    '-QUESTION-': '?',
};

const utilService = (() => {
    function debounce(func, delay) {
        let timeoutId;

        return function (...args) {
            clearTimeout(timeoutId);

            timeoutId = setTimeout(() => {
                func(...args);
            }, delay);
        };
    }

    // Encode special characters in a string to avoid conflicts with URL encoding
    function encodeSpecialChars(str) {
        return str.replaceAll(/[%#?]/g, (match) => mappings[match]);
    }

    // Decode special characters in a string
    function decodeSpecialChars(str) {
        return str.replaceAll(/-PERCENT-|-HASH-|-QUESTION-/g, (match) => reverseMappings[match]);
    }

    function getXsrfToken() {
        const xsrf = Cookies.get(GlobalCfg.XSRF_TOKEN);
        const xsrfParts = xsrf ? xsrf.split('|') : [];
        return xsrfParts[0] ? atob(xsrfParts[0]) : '';
    }

    return {
        debounce,
        encodeSpecialChars,
        decodeSpecialChars,
        getXsrfToken,
    };
})();

export default utilService;
